import config from 'config'
import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { withTranslation } from "react-i18next"
import { commonActions } from "srcReact/components"

const PricingRestrictive = (props) => {
  const { t } = props

  const handleClosePopin = () => {
    const { closePopin } = props

    closePopin()
  }

  return (
    <Fragment>
      <h2 className='popin-content--title'>{t('billing.popin.pricingRestrictive.title')}</h2>
      <p className='popin-content--text'>{t('billing.popin.pricingRestrictive.text')}</p>
      <div className="popin-content--image">
        <img src={`${config.assetUrl}/images/process.svg`} alt='process' />
      </div>
      <div className="popin-content--controllers with-link">
            <button type='button' className='button is-primary' onClick={() => handleClosePopin()}>{t('billing.popin.pricingRestrictive.btnPrimary')}</button>
      </div>
    </Fragment>
  )
}


const actionCreators = {
  closePopin: commonActions.closePopin
}

const ExtendedComponent = withTranslation('common')(PricingRestrictive)
const connectedPricingRestrictive = connect(null, actionCreators)(ExtendedComponent)

export { connectedPricingRestrictive as PricingRestrictive }

